import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  AccountSummaryWrapper,
  Container,
  Icon,
  Input,
  Search,
  TabContainer,
  TabLinkContainer,
} from "../../pages/Dashboard/styles/dashboard.style";
import GlobalStyles from "../../assets/globalStyle";
import { BsSearch } from "react-icons/bs";
import Loader from "../pageLoader/loader";
import { useSelector } from "react-redux";
import ErrorService from "../../services/errorService";
import hostelApi from "../../services/hostel";
import api from "../../services/ControlPanel";
import colors from "../../assets/colors.json";
import { AuthButton } from "../../pages/auth/Login.style";
import { LiaEllipsisVSolid } from "react-icons/lia";
import Modal from "../modal/Modal";
import Occupants from "./Occupants";
import Floors from "./Floors";
import Rooms from "./Rooms";
import moment from "moment";
import { paginateData } from "../../services/utils";
import Pagination from "../pagination_one/pagination";
import Bedspace from "./Bedspace";
import AddHostel from "./AddHostel";
import { MenuItem, MenuList } from "@mui/material";
import Popover from "@mui/material/Popover";
import { Box } from "@mui/system";
import AddHouse from "./AddHouse";
import { toast } from "react-toastify";

const CreateHouse = () => {
  const { admToken, user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [openCreateHouseModal, setOpenCreateHouseModal] = useState(false);
  const [openEditHouseModal, setOpenEditHouseModal] = useState(false);
  const [houses, setHouses] = useState([]);
  const [staff, setStaff] = useState([]);
  const [selectedHouse, setSelectedHouse] = useState(null);
  const [list, setList] = useState([]);
  const [itemOffSet, setitemOffSet] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [sQuery, setSQuery] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleAnchorClick = (event, house) => {
    setAnchorEl(event.currentTarget);
    setSelectedHouse(house);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  
  const filterSearch = async (e) => {
    const queryRegex = new RegExp(e.target.value, "i");
    const arr = houses.filter((item) => {
      return Object.values(item).some((val) => queryRegex.test(val));
    });
    setList(arr);
    setPageCount(0);
  };

  const getHouses = useCallback(async () => {
    setLoading(true);
    try {
      const res = await hostelApi.getHouses(admToken, user.schoolId);
      if (res.status && res.statusCode === 2) {
        setHouses(res.data);
      }
      res.status === 500 ||
        res.status === 400 ||
        (!res.status && ErrorService.displayErrorAlert(res));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [admToken, user.schoolId]);

  const handleDeleteHouse = async () => {
    if (!selectedHouse) return;
    
    try {
      setLoading(true);
      const res = await hostelApi.deleteHouse(admToken, selectedHouse.id);
      
      if (res?.status && res?.statusCode === 2) {
        toast.success(res.message || "House deleted successfully");
        getHouses();
        handleClose(); 
      } else if (res?.status === 500 || res?.status === 400 || !res?.status) {
        ErrorService.displayErrorAlert(res);
        console.log(res);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to delete house");
    } finally {
      setLoading(false);
    }
  };

  const getAllStaff = useCallback(async () => {
    try {
      const res = await api.getUsersCredential(admToken, user.schoolId, 3);
      if (res.status === true && res.statusCode === 2) {
        setStaff(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [admToken, user.schoolId]);

  useEffect(() => {
    getHouses();
    getAllStaff();
  }, [getAllStaff, getHouses]);

  const resetData = () => {
    setCurrentPage(1);
    console.log("reset data working");
    paginateData(houses, setList, 1, itemOffSet, setitemOffSet, setPageCount);
  };

  useEffect(() => {
    paginateData(
      houses,
      setList,
      currentPage,
      itemOffSet,
      setitemOffSet,
      setPageCount,
      10
    );
  }, [currentPage, houses, itemOffSet]);

  return (
    <Container>
      <GlobalStyles />
      {openCreateHouseModal && (
        <Modal
          content={
            <AddHouse
              setOpenCreateHouseModal={setOpenCreateHouseModal}
              getHouses={getHouses}
            />
          }
          size="large"
          onClose={setOpenCreateHouseModal}
          setOpenCreateHouseModal={setOpenCreateHouseModal}
          getHouses={getHouses}
        />
      )}
      {openEditHouseModal && (
        <Modal
          content={
            <AddHouse
              staff={staff}
              edit
              selectedHouse={selectedHouse}
              setOpenEditHouseModal={setOpenEditHouseModal}
              getHouses={getHouses}
            />
          }
          size="large"
          onClose={setOpenEditHouseModal}
        />
      )}
      <div className="flex justify-end mb-5">
        <AuthButton
          onClick={() => setOpenCreateHouseModal(true)}
          bg={colors.primary}
          className="!rounded-md"
        >
          Create House
        </AuthButton>
      </div>
      <TabContainer
        style={{
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          paddingBottom: "0px",
        }}
      >
        <TabLinkContainer bg="rgb(238, 224,241)">
          <Input>
            <Icon>
              <BsSearch />
            </Icon>
            <Search
              type="text"
              placeholder="Search For House"
              value={sQuery}
              onChange={(e) => {
                setSQuery(e.target.value);
                if (e.target.value.length > 2) {
                  filterSearch(e);
                }

                if (e.target.value === "") {
                  resetData();
                }
              }}
            />
          </Input>
        </TabLinkContainer>
        <AccountSummaryWrapper pt="0px">
          {loading ? (
            <Loader />
          ) : (
            <Box>
              <table
                style={{
                  borderRadius: "0px",
                  borderBottomLeftRadius: "20px",
                  borderBottomRightRadius: "20px",
                }}
              >
                <tr
                  className="tabel-head"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                  <th className="text-[0.75rem] xl:text-[1.1rem]">S/N</th>
                  <th className="text-[0.75rem] xl:text-[1.1rem]">House Name</th>
                  <th className="text-[0.75rem] xl:text-[1.1rem]">Actions</th>
                </tr>
                {list.map((house, index) => (
                  <React.Fragment key={index}>
                    <tr className="relative">
                      <td className="text-[0.75rem] xl:text-[1rem]">
                        {index + 1}
                      </td>
                      <td className="text-[0.75rem] xl:text-[1rem]">
                        {house.house_name}
                      </td>
                      <td className="text-[0.75rem] xl:text-[1rem]">
                        <button onClick={(e) => handleAnchorClick(e, house)}>
                          <LiaEllipsisVSolid className="w-6 h-6" />
                        </button>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </table>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <Box
                  sx={{
                    bgcolor: "#671E78",
                    color: "#fff",
                    fontFamily: "Gilroy-Regular",
                    px: 3,
                  }}
                >
                  <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
                    <MenuItem
                      onClick={() => {
                        setOpenEditHouseModal(true);
                        handleClose();
                      }}
                    >
                      Edit
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleDeleteHouse();
                      }}
                    >
                      Delete
                    </MenuItem>
                  </MenuList>
                </Box>
              </Popover>
            </Box>
          )}
        </AccountSummaryWrapper>
      </TabContainer>
      {pageCount > 1 && (
        <div
          style={{
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <Pagination
            pageCount={pageCount > 1 && pageCount}
            range={3}
            setCurrentPage={setCurrentPage}
          />
        </div>
      )}
    </Container>
  );
};

export default CreateHouse;
